export default __webpack_public_path__ + "static/2387-fb971d9dcdc498dac1dd68b9dd1e7765.gif";